export const roles = {
  superAdmin: "Super Admin",
  admin: "Admin",
  teacher: "Teachers",
  student: "Student",
};
